import CardSymphony from "elements/CardSymphony";
import useWebsiteBuilder, { WebsiteBuilder_paymentExists } from "Hooks/useWebsiteBuilder";
import WebsiteBuilderHeader from "../WebsiteBuilderHeader";
import WebsiteBuilderFooter from "../WebsiteBuilderFooter";
import { clsx } from "modules/Utils";

interface PaymentContentProps {
    className: string;
    contentIndex: number;
    tabSelectorComponent: React.ReactNode;
    id: string;
}

const PaymentContent = ({
    className,
    contentIndex,
    tabSelectorComponent,
    id,
}: PaymentContentProps) => {
    const {
        websiteContent
    } = useWebsiteBuilder() as WebsiteBuilder_paymentExists;

    const paymentContent = websiteContent[contentIndex].paymentContent;

    // NOTE: render()
    return (
        <CardSymphony
            className={clsx("paymentContentComponent", className)}
            id={id}
        >
            <WebsiteBuilderHeader
                contentIndex={contentIndex}
                rightSideContent={
                    tabSelectorComponent
                }
            />
            <WebsiteBuilderFooter
                className="paymentContentFooter"
                contentIndex={contentIndex}
            />
        </CardSymphony>
    )
}

export default PaymentContent;